/**
 * apps/web/src/lib/queryClient.ts
 *
 * The single React Query client. All server state flows through this cache;
 * components NEVER fetch with useEffect.
 *
 * Retry policy: do not retry auth/permission/validation failures (those are
 * deterministic), retry transient ones once.
 */

import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './api';

const NON_RETRYABLE_STATUS = new Set([400, 401, 403, 404, 409, 422]);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (isApiError(error) && NON_RETRYABLE_STATUS.has(error.status)) return false;
        return failureCount < 1;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});
